var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{
    name: 'section',
    params: { storeName: _vm.$store.storeName, id: _vm.sectionid  , name:_vm.name,lang: _vm.$i18n.locale},
  }}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image}})])]),_c('div',{staticStyle:{"text-align":"center","margin-top":"10px"}},[_c('h5',[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }